<template>
  <div class="form">
    <h1 class="form__title">{{ t('auth.new.title') }}</h1>
    <form @submit.prevent="confirmResetPassword" class="form__form">
      <ui-input
          :type="'password'"
          :placeholder="t('fields.password')"
          :rules="[isPasswordValid]"
          v-model="password"
      />
      <ui-input
          :type="'password'"
          :placeholder="t('fields.passwordConfirm')"
          :rules="[compareStrings]"
          v-model="passwordConfirm"
      />
      <ui-button
          :type="'submit'"
          class="form__button"
          :isDisabled="!isFormValid"
          :isLoading="isLoading"
      >
        {{ t('buttons.create') }}
      </ui-button>
    </form>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {isPasswordValid} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";
import {computed, ref} from "vue";
import UiButton from "@/components/ui/ui-button.vue";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";
import {useRoute, useRouter} from "vue-router";

const {t} = useI18n()
const route = useRoute()
const router = useRouter()

const uid = computed(() => {
  return route.query.uid ? route.query.uid : ''
})
const token = computed(() => {
  return route.query.token ? route.query.token : ''
})

const password = ref('')
const passwordConfirm = ref('')

const isLoading = ref(false)

const compareStrings = (v) => {
  if (v === password.value) return true
  return t('errors.compare')
}

const isFormValid = computed(() => {
  return (
      isPasswordValid(password.value) === true &&
      compareStrings(passwordConfirm.value) === true
  )
})

const confirmResetPassword = async () => {
  isLoading.value = true

  const res = await Auth.confirmResetPassword(uid.value, token.value, password.value, passwordConfirm.value)

  if (!res.errors) {
    await router.push({
      name: 'auth-login',
      params: {
        locale: localStorage.getItem('awe-user-locale') || 'en-gb'
      }
    })

    ElNotification({
      message: t('popup.successNewPassword'),
      type: 'success'
    })
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }

  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.form {
  &__title {
    color: #F3F3F3;
    text-align: center;
    font-size: 64px;
    font-weight: 700;
  }

  &__text {
    margin-top: 15px;
    color: $white;
    text-align: center;
    font-size: 20px;

    & a {
      transition: 0.2s;
      font-weight: 700;

      @include hover {
        color: #b7b7b7;
      }
    }
  }

  &__form {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  &__box {
    display: flex;
    align-items: flex-start;
    gap: 15px;
  }

  &__checkboxes {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 35px;
  }

  &__link {
    text-decoration: underline;
  }

  &__button {
    margin-top: 10px;
    width: fit-content !important;
    padding: 8px 40px;
  }
}
</style>